// extracted by mini-css-extract-plugin
export default {"sec-btn":"UpdateUser_sec-btn__iT352"};